import { Key, Entity } from '@briebug/ngrx-auto-entity';

@Entity({ modelName: 'Bid' })
export class Bid {
  @Key id?: string;
  jobName: string;
  jobAddress: string;
  contactName: string;
  phone: string;
  email: string;
  billingAddress: string;
  description: string;
  estMen: number;
  estHours: number;
  estDays: number;
  permitRequired: boolean;
  permitPrice: number;
  alt1Description: string;
  alt1Price: number;
  alt2Description: string;
  alt2Price: number;
  job: string;
  jobNumber?: string;
  total?: number;
  latestVersion?: number;
  createdBy?: string;
  created?: string;
  updated?: string;
}
